//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const topicOfWeightLoss = useStore((state) => state.topicOfWeightLoss);
  const setTopicOfWeightLoss = useStore((state) => state.setTopicOfWeightLoss);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.topicOfWeightLoss.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={topicOfWeightLoss}
          onChange={(value) => {
            setTopicOfWeightLoss(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'topic-of-weight-loss',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"I'm new to weight loss and need to learn a lot"}>
            <span>🤔</span> {t('onboarding.topicOfWeightLoss.options.needToLearn')}
          </Option>
          <Option value={'I have some experience but still need guidance'}>
            <span>🙌</span> {t('onboarding.topicOfWeightLoss.options.needGuidance')}
          </Option>
          <Option value={'I have lots of experience'}>
            <span>🤓</span> {t('onboarding.topicOfWeightLoss.options.haveExperience')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
